"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_select_1 = __importDefault(require("react-select"));
const react_1 = __importDefault(require("react"));
const table_1 = require("webapp-genric/dist/super-table/model/table");
const styled_components_1 = __importDefault(require("styled-components"));
const StyledWrapper = styled_components_1.default.div `
  min-width: 200px;
`;
exports.TableView = ({ view, tableViews, onAction }) => {
    const value = view
        ? tableViews.find((x) => x.value == view) || tableViews[0]
        : tableViews[0];
    const onChange = (value, actionMeta) => {
        onAction({
            action: "event",
            event: table_1.Events.PARAM_CHANGE,
            params: { view: value.value },
        });
    };
    return (react_1.default.createElement("div", { className: "d-flex align-items-center" },
        react_1.default.createElement("span", { className: "mr-2" }, "View"),
        react_1.default.createElement(StyledWrapper, null,
            react_1.default.createElement(react_select_1.default, { value: value, options: tableViews, onChange: onChange }))));
};
//# sourceMappingURL=TableView.js.map